import { createContext, useContext, useState } from "react";

export const EmployeeContext = createContext(null);

export const EmployeeProvider = ({ children }) => {
    const [employeeId, setEmployeeIdState] = useState(
        () => localStorage.getItem("employeeId") || localStorage.getItem("ep_employeeId") || ""
    );

    const setEmployeeId = (id) => {
        localStorage.setItem("ep_employeeId", id);
        setEmployeeIdState(id);
    };

    const clearEmployeeId = () => {
        localStorage.removeItem("ep_employeeId");
        setEmployeeIdState("");
    };

    return (
        <EmployeeContext.Provider value={{ employeeId, setEmployeeId, clearEmployeeId }}>
            {children}
        </EmployeeContext.Provider>
    );
};

export const useEmployee = () => useContext(EmployeeContext);

export default EmployeeProvider;
